import { Button, Modal, TextInput } from '@mantine/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateDirectoryForm } from 'src/Hooks/Forms/useCreateDirectoryForm';
import { useCreateDirectory } from 'src/Hooks/Mutations/useCreateDirectory';

import styles from './CreateDirectoryModal.module.scss';
import { Props } from './CreateDirectoryModal.types';

const CreateDirectoryModal = ({ open, onClose, path }: Props) => {
  const { t } = useTranslation();
  const { form } = useCreateDirectoryForm();
  const { mutate, isLoading } = useCreateDirectory({ onSuccess: onClose });

  useEffect(() => {
    if (open) form.reset();
  }, [open]);

  return (
    <Modal
      opened={open}
      title={
        <div className={styles.title}>
          {t('documents.createDirectoryModal.title', 'Ajouter un dossier')}
        </div>
      }
      withCloseButton={true}
      onClose={onClose}
    >
      <div className={styles.container}>
        <form onSubmit={form.onSubmit(values => mutate({ path, name: values.folderName }))}>
          <TextInput
            placeholder={t('documents.createDirectoryModal.inputPlaceholder', 'Nom du dossier')}
            disabled={isLoading}
            {...form.getInputProps('folderName')}
          />

          <div className={styles.buttons}>
            <Button loading={isLoading} type={'submit'}>
              {t('documents.createDirectoryModal.create', 'Créer')}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CreateDirectoryModal;
